// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7d75fc9b","title":"_22554fc8","icon":"_8f4e8423"};